"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PinAuth = exports.Auth0 = exports.OAuth = exports.AuthResultStatus = void 0;
var axios_1 = __importDefault(require("axios"));
var jwt_decode_1 = __importDefault(require("jwt-decode"));
var AuthResultStatus;
(function (AuthResultStatus) {
    AuthResultStatus[AuthResultStatus["SUCCESS"] = 200] = "SUCCESS";
    AuthResultStatus[AuthResultStatus["FAILED"] = 403] = "FAILED";
})(AuthResultStatus = exports.AuthResultStatus || (exports.AuthResultStatus = {}));
var OAuth = /** @class */ (function () {
    function OAuth() {
        this.authenticated = false;
    }
    OAuth.prototype.isAuthenticated = function () {
        return this.authenticated;
    };
    OAuth.prototype.login = function (_a) {
        var username = _a.username, password = _a.password;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                if (username === 'Jane' && password === 'password123') {
                    this.authenticated = true;
                    return [2 /*return*/, { result: AuthResultStatus.SUCCESS }];
                }
                return [2 /*return*/, { result: AuthResultStatus.FAILED }];
            });
        });
    };
    OAuth.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.authenticated = false;
                return [2 /*return*/, {
                        result: AuthResultStatus.FAILED,
                    }];
            });
        });
    };
    return OAuth;
}());
exports.OAuth = OAuth;
var Auth0 = /** @class */ (function () {
    function Auth0(config) {
        this.config = config;
    }
    Auth0.prototype.isAuthenticated = function () {
        var access_token = localStorage.getItem('access_token');
        if (access_token && !this.isTokenExpired()) {
            return true;
        }
        else {
            return false;
        }
    };
    Auth0.prototype.isTokenExpired = function () {
        var access_token = localStorage.getItem('access_token');
        if (access_token) {
            var decoded = jwt_decode_1.default(access_token);
            if (decoded.exp && (Date.now() <= (decoded.exp * 1000))) {
                return false;
            }
            else {
                return true;
            }
        }
        else {
            return true;
        }
    };
    Auth0.prototype.getAccessToken = function () {
        return localStorage.getItem('access_token');
    };
    Auth0.prototype.getIdToken = function () {
        return localStorage.getItem('id_token');
    };
    Auth0.prototype.getUser = function () {
        var access_token = localStorage.getItem('access_token');
        var id_token = localStorage.getItem('id_token');
        if (access_token && id_token) {
            var decoded_access_token = jwt_decode_1.default(access_token);
            var decoded_id_token = jwt_decode_1.default(id_token);
            var user = __assign(__assign({}, decoded_access_token[this.config.audience + "/user"]), decoded_id_token);
            return user;
        }
        else {
            return null;
        }
    };
    Auth0.prototype.login = function (username, password) {
        return __awaiter(this, void 0, void 0, function () {
            var payload, url, res, access_token, id_token, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        payload = {
                            grant_type: this.config.grant_type,
                            audience: this.config.audience,
                            scope: this.config.scope,
                            client_id: this.config.client_id,
                            username: username,
                            password: password
                        };
                        url = this.config.endpoint + "/oauth/token";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios_1.default.post(url, payload)];
                    case 2:
                        res = _a.sent();
                        access_token = res.data.access_token;
                        id_token = res.data.id_token;
                        localStorage.setItem('access_token', access_token);
                        localStorage.setItem('id_token', id_token);
                        return [2 /*return*/, { result: AuthResultStatus.SUCCESS }];
                    case 3:
                        err_1 = _a.sent();
                        return [2 /*return*/, { result: AuthResultStatus.FAILED, payload: err_1.response }];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Auth0.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                localStorage.removeItem('access_token');
                localStorage.removeItem('id_token');
                return [2 /*return*/, {
                        result: AuthResultStatus.FAILED
                    }];
            });
        });
    };
    Auth0.prototype.resetPassword = function (email) {
        var payload = {
            client_id: this.config.client_id,
            connection: this.config.connection,
            email: email
        };
        var url = this.config.endpoint + "/dbconnections/change_password";
        return axios_1.default.post(url, payload);
    };
    return Auth0;
}());
exports.Auth0 = Auth0;
var PinAuth = /** @class */ (function () {
    function PinAuth(endpoint) {
        this.endpoint = endpoint;
    }
    PinAuth.prototype.login = function (pin) {
        return __awaiter(this, void 0, void 0, function () {
            var payload, res, token, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        payload = { pin: pin };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios_1.default.post(this.endpoint, payload)];
                    case 2:
                        res = _a.sent();
                        token = res.data.token;
                        localStorage.setItem('token', token);
                        localStorage.setItem('token_data', JSON.stringify(res.data));
                        return [2 /*return*/, { result: AuthResultStatus.SUCCESS }];
                    case 3:
                        err_2 = _a.sent();
                        return [2 /*return*/, { result: AuthResultStatus.FAILED, payload: err_2.response }];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    PinAuth.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                localStorage.removeItem('token');
                localStorage.removeItem("token_data");
                return [2 /*return*/, { result: AuthResultStatus.FAILED }];
            });
        });
    };
    PinAuth.prototype.isAuthenticated = function () {
        var token = localStorage.getItem('token');
        return token ? true : false;
    };
    PinAuth.prototype.getToken = function () {
        return localStorage.getItem("token");
    };
    PinAuth.prototype.getTokenData = function () {
        var tokenData = localStorage.getItem("token_data");
        return tokenData ? JSON.parse(tokenData) : {};
    };
    return PinAuth;
}());
exports.PinAuth = PinAuth;
